import { setMilliseconds, setMinutes, setSeconds } from "date-fns";

/**
 * Formats a given Date object or string to 'hh:mm AM/PM'.
 * @param time - The time to format. Can be a Date object or a preformatted string.
 * @returns A string representing the formatted time in 'hh:mm AM/PM'.
 */
export function formatTime(time: Date | string): string {
  if (typeof time === 'string') return time;
  
  // Create new Date object to prevent mutation issues
  const safeDate = new Date(time);
  
  const hours = safeDate.getHours();
  const minutes = safeDate.getMinutes();
  const ampm = hours >= 12 ? 'PM' : 'AM';
  const formattedHours = hours % 12 || 12;
  const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
  return `${formattedHours}:${formattedMinutes} ${ampm}`;
}

/**
 * Adds the specified number of minutes to a given date.
 * @param date - The original date to modify.
 * @param minutes - The number of minutes to add.
 * @returns A new Date object with the specified minutes added.
 */
export function addMinutes(date: Date, minutes: number): Date {
    const newDate = new Date(date);
    newDate.setMinutes(newDate.getMinutes() + minutes);
    return newDate;
  }


export  function updateTime(originalDate: Date, newTime: string, isStart?: boolean): Date {
    originalDate = new Date(originalDate)
    if(!newTime){
      return isStart ? new Date(originalDate.setHours(0, 0, 0, 0)) : new Date(originalDate.setHours(23, 59, 59, 999));
    }
    const [time, modifier] = newTime.split(" ");
    let [hours, minutes] = time.split(":").map(Number);
  
    // Convert to 24-hour format
    if (modifier === "PM" && hours !== 12) {
      hours += 12;
    } else if (modifier === "AM" && hours === 12) {
      hours = 0;
    }
  
    // Set new hours and minutes to the original date
    originalDate.setHours(hours);
    originalDate.setMinutes(minutes);
    originalDate.setSeconds(0); // Optionally reset seconds
  
    return originalDate;
  }


  export function getNearestFullTime(date = new Date()) {
    const currentMinutes = date.getMinutes();
    
    // Calculate the nearest quarter hour
    const roundedMinutes = Math.round(currentMinutes / 15) * 15;
  
    // Set the minutes to the nearest quarter, and reset seconds/milliseconds
    const nearestFullTime = setMilliseconds(
      setSeconds(setMinutes(date, roundedMinutes), 0),
      0
    );
  
    // If roundedMinutes is 60, add an hour and reset to 0 minutes
    return roundedMinutes === 60 ? addMinutes(nearestFullTime, 15) : nearestFullTime;
  }


  export function convertTo24HourFormat(time12h) {
    // Split by space to separate time from AM/PM
    const [time, modifier] = time12h.split(' ');
    
    // Split time into hours and minutes
    let [hours, minutes] = time.split(':');
    
    // Convert string hours to number
    let hoursNum = parseInt(hours, 10);
  
    // Handle special case for 12 AM
    if (hoursNum === 12 && modifier === 'AM') {
      hoursNum = 0;
    }
    
    // Handle PM by adding 12 to the hour (except for 12 PM which is already 12)
    if (modifier === 'PM' && hoursNum !== 12) {
      hoursNum += 12;
    }
    
    // Pad hours with 0 if needed (e.g., 0 => 00, 1 => 01)
    const hours24 = hoursNum.toString().padStart(2, '0');
  
    return `${hours24}:${minutes}`;
  }